import { centerCenter, end, scrollY, someChildWillScroll } from 'csstips';
import { percent, px, rem } from 'csx';
import { style } from 'typestyle';
import { NestedCSSProperties } from 'typestyle/lib/types';
import { colorGreyAccent } from '../theme/color';
import { mediaDesktop } from '../theme/media';
import { ModalContainerStyle, ModalChildStyle, ModalPadding } from './modal';
import { shadowElevation1 } from '../theme/shadow';

export const ScrollableOverlayContainerStyle: NestedCSSProperties = {
  ...ModalContainerStyle,
  ...end,
  textAlign: 'left',
  zIndex: Number.MAX_SAFE_INTEGER,
};

export const ScrollableOverlayWrapperStyle: NestedCSSProperties = {
  ...ModalChildStyle,
  ...someChildWillScroll,
  padding: 0,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  maxHeight: `calc(100% - 4rem)`,
  position: 'relative',
  ...mediaDesktop({
    width: percent(50),
    borderRadius: rem(1),
    maxHeight: `calc(100% - 5rem)`,
    marginBottom: rem(1),
  }),
};

export const ScrollableOverlayCloseButtonStyle: NestedCSSProperties = {
  ...centerCenter,
  ...shadowElevation1,
  position: 'absolute',
  width: px(32),
  height: px(32),
  borderRadius: px(32),
  right: px(8),
  top: px(8),
  border: 0,
  backgroundColor: colorGreyAccent.toHexString(),
  $nest: {
    '& > svg': {
      position: 'absolute',
    },
  },
};

export const ScrollableOverlayHeaderStyle: NestedCSSProperties = {
  ...ModalPadding,
};

export const ScrollableOverlayBodyStyle: NestedCSSProperties = {
  ...scrollY,
  ...ModalPadding,
  flexShrink: 4,
};

export const ScrollableOverlayFooterStyle: NestedCSSProperties = {
  ...ModalPadding,
};

export default {
  container: style(ScrollableOverlayContainerStyle),
  wrapper: style(ScrollableOverlayWrapperStyle),
  closeButton: style(ScrollableOverlayCloseButtonStyle),
  header: style(ScrollableOverlayHeaderStyle),
  body: style(ScrollableOverlayBodyStyle),
  footer: style(ScrollableOverlayFooterStyle),
};
